import isEmpty from 'lodash/isEmpty';
import {
  INSTORE_CURATED_OFFERS_HEADING_GET_FAILURE,
  INSTORE_CURATED_OFFERS_HEADING_GET_SUCCESS,
  INSTORE_CURATED_OFFERS_HEADING_FILL,
} from '../actions/types';

const initialState = {
  isLoading: false,
  isLoaded: false,
  data: {},
};

const handleResponse = (response) => {
  if (isEmpty(response)) {
    return { sectionTitle: '' };
  }

  const { assets: { text } } = response[0];

  return {
    sectionTitle: text,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INSTORE_CURATED_OFFERS_HEADING_FILL: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        data: action.payload,
      };
    }
    case INSTORE_CURATED_OFFERS_HEADING_GET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        data: handleResponse(action.payload.response),
      };
    }
    case INSTORE_CURATED_OFFERS_HEADING_GET_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        data: [],
      };
    }
    default: {
      const { options = {} } = action;
      if (options.success === INSTORE_CURATED_OFFERS_HEADING_GET_SUCCESS) {
        return {
          ...state,
          isLoading: true,
          isLoaded: false,
        };
      }
    }
  }

  return state;
};
